import { render, staticRenderFns } from "./_partyRelation.vue?vue&type=template&id=d49210e2&scoped=true"
import script from "./_partyRelation.vue?vue&type=script&lang=js"
export * from "./_partyRelation.vue?vue&type=script&lang=js"
import style0 from "./_partyRelation.vue?vue&type=style&index=0&id=d49210e2&prod&lang=scss&scoped=true"
import style1 from "./_partyRelation.vue?vue&type=style&index=1&id=d49210e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49210e2",
  null
  
)

export default component.exports